import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SignupView from '../components/screens/SignupView';

const initialForm = {
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  kidsNames: '',
  locationTrackingEnabled: false,
  password: '',
  confirmPassword: '',
};

function SignupPage({ auth }) {
  const navigate = useNavigate();
  const [form, setForm] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [signupStatus, setSignupStatus] = useState({
    type: 'idle',
    message: 'Enter account details to continue.',
  });

  function handleChange(field, value) {
    setForm((current) => ({ ...current, [field]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (!form.email.trim() || !form.password.trim()) {
      setSignupStatus({ type: 'error', message: 'Email and password are required.' });
      return;
    }

    if (form.password !== form.confirmPassword) {
      setSignupStatus({ type: 'error', message: 'Passwords do not match.' });
      return;
    }

    if (form.password.length < 6) {
      setSignupStatus({ type: 'error', message: 'Password must be at least 6 characters.' });
      return;
    }

    try {
      setIsSubmitting(true);
      setSignupStatus({ type: 'loading', message: 'Creating account...' });
      await auth.signUpWithEmail(form);
      setSignupStatus({ type: 'success', message: 'Account created.' });
      navigate('/history', { replace: true });
    } catch (error) {
      setSignupStatus({
        type: 'error',
        message: error.message || 'Unable to create account right now.',
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <SignupView
      backendUrl={auth.backendUrl}
      signupStatus={signupStatus}
      isFirebaseConfigured={auth.isFirebaseConfigured}
      isSubmitting={isSubmitting}
      form={form}
      onChange={handleChange}
      onSubmit={handleSubmit}
    />
  );
}

export default SignupPage;
